/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Formatters. e.g. phone-number formatter, number formatter, date formatter
 */

export const formatDomesticNumber = (number: string) => {
  // Remove non-numerals and leading 0's and 1's
  const rawNumber = number
    ? number
        .slice(0, 26)
        .replace(/\D/g, '')
        .replace(/^[01]+/, '')
    : ''
  const len = rawNumber.length
  let domesticNumber = ''

  if (len > 10) {
    domesticNumber =
      `(${rawNumber.slice(0, 3)}) ${rawNumber.slice(3, 6)}-` +
      `${rawNumber.slice(6, 10)} ext. ${rawNumber.slice(10)}`
  } else if (len >= 6) {
    domesticNumber = `(${rawNumber.slice(0, 3)}) ${rawNumber.slice(
      3,
      6
    )}-${rawNumber.slice(6, 10)}`
  } else if (len >= 3) {
    domesticNumber = `(${rawNumber.slice(0, 3)}) ${rawNumber.slice(3, 6)}`
  } else if (len > 0) {
    domesticNumber = `(${rawNumber}`
  }
  return domesticNumber
}

export const phoneNumberFormatter = (number: string) => {
  return number.charAt(0) === '+'
    ? `+${number.replace(/[^\d\s]/g, '')}`
    : formatDomesticNumber(number)
}

export const phoneNumberToHref = (number: string) => {
  return number.replace(/[-()\s]/g, '').replace('ext.', ',')
}

interface CurrencyFormatterOptions {
  showCents?: boolean | 'exceptZero'
  stripNonDigits?: boolean
  symbol?: string
  postSymbol?: string
}

export const currencyFormatter = (
  number: number | string,
  {
    stripNonDigits = true,
    showCents = true,
    symbol = '',
    postSymbol = '',
  }: CurrencyFormatterOptions = {}
) => {
  let rawNumber: string
  if (stripNonDigits || typeof number === 'number') {
    rawNumber = String(number).replace(/[^\d.-]/g, '')
    if (!rawNumber) {
      return ''
    }
  } else {
    const m = number.match(/^-?\$?-?(\d+(?:\.\d{1,2})?)$/)
    if (m) {
      rawNumber = m[1]
    } else {
      return number
    }
  }
  const negative = rawNumber?.startsWith?.('-') ? '-' : ''
  const numberParts = rawNumber.split('.')
  const dollars = numberParts[0]
    .replace(/\D/g, '')
    .replace(/^0+(?=\d)/, '')
    .replace(/\d{1,3}(?=(\d\d\d)+$)/g, '$&,')
  const rawCents =
    showCents && numberParts[1] ? numberParts[1].replace(/\D/g, '') : ''
  const cents = `${rawCents.charAt(0) || '0'}${rawCents.charAt(1) || '0'}`
  return `${negative}${symbol}${dollars || '0'}${
    showCents === true || (showCents === 'exceptZero' && cents !== '00')
      ? `.${cents}`
      : ''
  }${postSymbol}`
}

export const currencyToCents = (value: number) => {
  return Math.round(value * 100)
}

export const currencyFromCents = (value: number) => {
  return Number((value * 0.01).toFixed(2))
}
